export const getCheckpointReferences = ( apiInstance: API.Client ) => ( uid: string ) => (
  apiInstance.Entity.collection( 'checkpoint' ).getReferences( uid )
)